// extracted by mini-css-extract-plugin
module.exports = {"content":"PotentialCustomers_index_content__2Lwn4"};